import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

export const UserWithdrawWalletCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="user" reference="users" label="User">
        <AutocompleteInput optionText="username" filterToQuery={(q) => ({ username: q })} />
      </ReferenceInput>

      <ReferenceInput source="method" reference="withdraw-methods" label="Method">
        <AutocompleteInput optionText="name" filterToQuery={(q) => ({ name: q })} />
      </ReferenceInput>

      <TextInput source="wallet_number" label="Wallet number" isRequired />
    </SimpleForm>
  </Create>
);